var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pattern_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1547.91 1043.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pattern_svg__cls-1{fill:#007040}.pattern_svg__cls-2{fill:#ff6063}.pattern_svg__cls-3{fill:#ff992a}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 282.24,
    cy: 306.66,
    rx: 35.58,
    ry: 7.65,
    transform: "rotate(-25.63 343.853 239.79)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 1476.82,
    cy: 15.9,
    rx: 35.73,
    ry: 36.29,
    transform: "rotate(-53.05 1514.372 -9.14)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 338.09,
    cy: 465.73,
    rx: 36.01,
    ry: 16.32,
    transform: "rotate(-25.95 399.137 399.835)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 297.21,
    cy: 55.18,
    rx: 35.38,
    ry: 25.3,
    transform: "rotate(-54.86 334.013 31.48)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 959.61,
    cy: 163.57,
    rx: 34.36,
    ry: 34.46,
    transform: "rotate(-89.4 986.494 156.39)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 208.65,
    cy: 920.3,
    rx: 27.11,
    ry: 33.29,
    transform: "rotate(-2.37 710.445 83.373)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 708.69,
    cy: 329.31,
    rx: 30.35,
    ry: 36.26,
    transform: "rotate(-28.46 765.582 270.3)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 65.64,
    cy: 471.97,
    rx: 10.19,
    ry: 32.89,
    transform: "rotate(-20.15 139.54 383.48)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 441.22,
    cy: 817.09,
    rx: 37.02,
    ry: 19.09,
    transform: "rotate(-15.46 532.385 697.965)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 1058.05,
    cy: 1000.34,
    rx: 19.94,
    ry: 38.28,
    transform: "rotate(-76.14 1088.3 988.004)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 29,
    cy: 619.59,
    rx: 38.6,
    ry: 38.74,
    transform: "rotate(-4.49 302.182 183.654)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 664.25,
    cy: 746.64,
    rx: 25.16,
    ry: 36.23,
    transform: "rotate(-68.8 696.052 732.577)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 1287.07,
    cy: 619.33,
    rx: 27.65,
    ry: 37.27,
    transform: "rotate(-89.76 1314.558 611.807)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 453.7,
    cy: 984.06,
    rx: 32.96,
    ry: 30.82,
    transform: "rotate(-32.56 505.554 934.198)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 0.47,
    cy: 939.29,
    rx: 38.74,
    ry: 32.59,
    transform: "rotate(-48.02 40.471 910.023)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 1242.11,
    cy: 1006.13,
    rx: 35.58,
    ry: 7.65,
    transform: "rotate(-25.63 1303.93 939.34)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 1032.13,
    cy: 701.35,
    rx: 36.01,
    ry: 16.32,
    transform: "rotate(-25.95 1093.266 635.48)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 1280.27,
    cy: 422.14,
    rx: 27.11,
    ry: 33.29,
    transform: "rotate(-2.37 1780.895 -414.404)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 730.34,
    cy: 921.29,
    rx: 30.35,
    ry: 36.26,
    transform: "rotate(-28.46 787.22 862.176)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 1383.31,
    cy: 875.37,
    rx: 10.19,
    ry: 32.89,
    transform: "rotate(-20.15 1457.183 786.865)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 1047.7,
    cy: 525.34,
    rx: 37.02,
    ry: 19.09,
    transform: "rotate(-15.46 1138.699 406.323)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 818.66,
    cy: 45.3,
    rx: 32.62,
    ry: 37.53,
    transform: "rotate(-43.05 861.492 10.972)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 655.74,
    cy: 115.06,
    rx: 19.94,
    ry: 38.28,
    transform: "rotate(-76.14 686.015 102.741)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 42.89,
    cy: 136.59,
    rx: 5.51,
    ry: 36.18,
    transform: "rotate(-14.35 139.982 7.575)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-1",
    cx: 1280.57,
    cy: 86.46,
    rx: 32.65,
    ry: 29.72,
    transform: "rotate(-41.88 1324.218 50.764)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 1459.92,
    cy: 722.84,
    rx: 38.6,
    ry: 38.74,
    transform: "rotate(-4.49 1734.167 286.927)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-3",
    cx: 824.67,
    cy: 595.79,
    rx: 25.16,
    ry: 36.23,
    transform: "rotate(-68.69 856.812 580.204)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "pattern_svg__cls-2",
    cx: 999.07,
    cy: 290.41,
    rx: 32.96,
    ry: 30.82,
    transform: "rotate(-32.9 1045.259 243.503)"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgPattern as ReactComponent };